import { LogicMiddleware } from '@zervant/reactcomponents'

import { ACTIONS } from './Global/Actions'
import { StateInterface } from './Interfaces/StateInterface'

export const Middleware = new LogicMiddleware<StateInterface>(ACTIONS)
